import { CheckSheet, CheckSheetAssignment } from '@completion/models';
import { BulkAction, BulkActionTypes } from '@completion/actions';

export const initialState: BulkState = {
  availableCheckSheets: [],
  availableSourceCheckSheetAssignments: [],
  availableTargetCheckSheetAssignments: [],
  selectedCheckSheet: null,
  sourceCSAssignment: null,
  targetCSAssignments: [],
};

export interface BulkState {
  availableCheckSheets: CheckSheet[];
  availableSourceCheckSheetAssignments: CheckSheetAssignment[];
  availableTargetCheckSheetAssignments: CheckSheetAssignment[];
  selectedCheckSheet?: CheckSheet;
  sourceCSAssignment?: CheckSheetAssignment;
  targetCSAssignments?: CheckSheetAssignment[];
}

export function bulkReducer(state: BulkState = initialState, action: BulkAction): BulkState {
  switch (action.type) {
    case BulkActionTypes.LoadAvailableCheckSheetsSuccess:
      return {
        ...state,
        availableCheckSheets: action.checkSheets,
      };
    case BulkActionTypes.LoadAvailableSourceCheckSheetAssignmentsSuccess:
      return {
        ...state,
        availableSourceCheckSheetAssignments: action.checkSheetAssignments,
      };
    case BulkActionTypes.LoadAvailableTargetCheckSheetAssignmentsSuccess:
      return {
        ...state,
        availableTargetCheckSheetAssignments: action.checkSheetAssignments,
      };
    case BulkActionTypes.CopySourceToTargetsSuccess:
      return initialState;
    case BulkActionTypes.SetSelectedCheckSheet:
      return {
        ...state,
        selectedCheckSheet: action.checkSheet,
      };
    case BulkActionTypes.SetSourceCheckSheetAssignment:
      return {
        ...state,
        sourceCSAssignment: action.checkSheetAssignment,
      };

    case BulkActionTypes.AddTargetCheckSheetAssignment:
      return {
        ...state,
        targetCSAssignments: [...state.targetCSAssignments, action.checkSheetAssignment],
      };

    case BulkActionTypes.RemoveTargetCheckSheetAssignment:
      return {
        ...state,
        targetCSAssignments: state.targetCSAssignments.filter((assignment) => assignment.id !== action.checkSheetAssignment.id),
      };

    default:
      return state;
  }
}
